import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { getChannels, withdraw, withdrawSettingByUserID } from '@/api/withdraw';
import { PAYMENT_TYPE } from '@/constants';
import { PayChannel } from '@/types/common';
import { useWithdrawStore } from '@/stores/withdraw';
import WithdrawViewOne from '@/themes/themeOne/withdraw/withdrawView.vue';
import WithdrawViewTwo from '@/themes/themeTwo/withdraw/withdrawView.vue';
import { WithdrawViewData } from './supportScript';
import WithdrawPopup from './withdrawPopup.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawView',
  setup(__props) {

const userStore = useUserStore()
const themeStore = useThemeStore()
const withdrawStore = useWithdrawStore()
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const isLoading = ref(false)

const channelList = ref<PayChannel[]>([])
const activeChannel = ref<PayChannel>({
    id: 0,
    name: ''
})
const selectedAmount = ref<number | string>('')
const balanceAmount = computed(() => userStore.balance)
const activeButton = ref(false)
const uId = computed(() => userStore.id)

const dataSet = computed<WithdrawViewData>(() => ({
    channelList: channelList.value,
    activeChannel: activeChannel.value,
    balanceAmount: balanceAmount.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    uId: uId.value
}))

const withdrawRef = ref()
const withdrawConfirmRef = ref()

const selectChannel = (item: PayChannel) => {
    activeChannel.value = item
    withdrawStore.setSelectedWithdrawChannel(activeChannel.value)
}

const inputValueChange = (val: any) => {

    if (balanceAmount.value < val) {
        selectedAmount.value = balanceAmount.value
    } else {
        selectedAmount.value = val
    }
    if (val > 0) {
        activeButton.value = true
    } else {
        activeButton.value = false
    }
}
const showError = (message: string) => {
    isLoading.value = false
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    isLoading.value = false
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const showLoading = (val: boolean) => {
    isLoading.value = val
    statusRef.value.open()
}
const getChannelList = () => {
    getChannels({ paymentType: PAYMENT_TYPE.WITHDRAW }).then(res => {
        channelList.value = res.data;
        withdrawStore.setWithdrawList(channelList.value)
        activeChannel.value = channelList.value[0] || { id: 0, name: '' };
        withdrawStore.setSelectedWithdrawChannel(activeChannel.value)
    }).catch(err => {
        showError(err)
    });
}
const confirmWithdraw = () => {
    let data = {
        uid: uId.value
    }
    withdrawSettingByUserID(data).then(res => {
        let resData = res.data
        withdrawStore.setWithdrawInfo(resData)
        // withdrawRef.value.openWithdrawConfirm(selectedAmount.value, resData)
        withdrawConfirmRef.value.open(selectedAmount.value, resData)

    }).catch(err => {
        showError(err);
    })

}
onMounted(() => {
    userStore.getInfo()
    getChannelList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(WithdrawViewOne, {
            ref_key: "withdrawRef",
            ref: withdrawRef,
            "data-set": dataSet.value,
            onInputValueChange: inputValueChange,
            onSelectChannel: selectChannel,
            onConfirmWithdraw: confirmWithdraw
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(WithdrawViewTwo, {
            ref_key: "withdrawRef",
            ref: withdrawRef,
            "data-set": dataSet.value,
            onInputValueChange: inputValueChange,
            onSelectChannel: selectChannel,
            onConfirmWithdraw: confirmWithdraw,
            onShowError: showError,
            onShowSuccess: showSuccess,
            onShowLoading: showLoading
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value,
      isLoading: isLoading.value
    }, null, 8, ["is-show-success", "content", "isLoading"]),
    _createVNode(WithdrawPopup, {
      ref_key: "withdrawConfirmRef",
      ref: withdrawConfirmRef
    }, null, 512)
  ], 64))
}
}

})